import { CHECK_RESTAURANT_OPERATION_SERVICE, GET_RESTAURANTS_BASED_ON_CATEGORY, GET_RESTAURANTS_CATEGORIES,GET_RESTAURANT_DELIVERY_CHARGES } from "./actionTypes";

const initialState = {
    is_operational: "",
    filtered_restaurants: [],
    restaurants_categories: [],
    restaurant_delivery_charges:''
};

export default function(state = initialState, action) {
    switch (action.type) {
        case CHECK_RESTAURANT_OPERATION_SERVICE:
            return { ...state, is_operational: action.payload };
        case GET_RESTAURANTS_BASED_ON_CATEGORY:
            return { ...state, filtered_restaurants: action.payload };
        case GET_RESTAURANTS_CATEGORIES:
            return { ...state, restaurants_categories: action.payload };
        case GET_RESTAURANT_DELIVERY_CHARGES:
            return { ...state, restaurant_delivery_charges: action.payload };
        default:
            return state;
    }
}
